import { Expose } from 'class-transformer';
import { IsNotEmpty } from 'class-validator';

export abstract class BaseLivingSituation {
  @Expose()
  @IsNotEmpty()
  type?: string;
}
